module.exports = __webpack_public_path__ + "img/levelbio_vit.7041b0e0.svg";